<template>
    <div>
        <!-- <b-modal :active.sync="showMakeAdminModal" aria-modal :width="800" scroll="keep">
            <header class="modal-card-head">
                <p class="modal-card-title">Waarschuwing</p>
            </header>
            <section class="modal-card-body" style="border-radius:0;">
                <p>Weet je zeker dat je {{ makeAdminUser.name }} administrator wilt maken?</p>
            </section>
            <footer class="modal-card-foot">
                <b-button type="is-light" @click="showMakeAdminModal = false">Annuleren</b-button>
                <b-button type="is-success"  @click="makeAdmin" :loading="makeAdminLoading" :disabled="makeAdminLoading">Ja, maak administrator</b-button>
            </footer>
        </b-modal> -->

        <!-- <b-modal :active.sync="showDeleteUserModal" aria-modal :width="800" scroll="keep">
            <header class="modal-card-head">
                <p class="modal-card-title">Waarschuwing</p>
            </header>
            <section class="modal-card-body" style="border-radius:0;">
                <p>Weet je zeker dat je {{ deleteThisUser.name }} wilt verwijderen?</p>
            </section>
            <footer class="modal-card-foot">
                <b-button type="is-light" @click="showDeleteUserModal = false">Annuleren</b-button>
                <b-button type="is-danger"  @click="deleteUser" :loading="deleteUserLoading" :disabled="deleteUserLoading">Ja, verwijderen</b-button>
            </footer>
        </b-modal> -->

        <div class="row">
            <div class="column small-9">
                <PageTitle title="Gebruikers" :total="total" :loading="loading" />
            </div>
            <div class="column small-3 text-right">
                <b-button type="is-dark" v-if="user.is_admin" @click="addUserModal()">Gebruiker toevoegen</b-button>
            </div>
        </div>

        <div class="row">
            <div class="column">
                <UsersOverviewTable
                    ref="UsersOverviewTable"
                    from="AccountsOverview"
                    :organisation_id="dataBelongsTo ? dataBelongsTo : null"
                    @passTotal="total = $event"
                    @passLoading="loading = $event"
                />
                <!-- <b-table
                    :data="records"
                    :striped="true"
                    :loading="loading"
                    :mobile-cards="true"

                    backend-pagination
                    :total="total"
                    :per-page="perPage"
                    @page-change="onPageChange"
                    backend-sorting
                    :default-sort-direction="sortOrder"
                    :default-sort="[sortField, sortOrder]"
                    @sort="onSort"

                    :paginated="paginated"
                    :sort-icon="'chevron-up'"
                >
                    <template>
                        <b-table-column v-slot="props" field="organisation" label="Org." width="50" :visible="user && user.role == 'pit'" class="admin">
                            <b-button type="is-primary" outlined tag="router-link" size="is-small" :to="{ name: 'OrganisationsRecord', params: {id: props.row.organisation} }">
                                {{ _.has(organisations, props.row.organisation) ? organisations[props.row.organisation].short_name : '-' }}
                            </b-button>
                        </b-table-column>

                        <b-table-column v-slot="props" field="name" label="Naam" sortable>
                            {{ props.row.name }}
                        </b-table-column>

                        <b-table-column v-slot="props" field="email" label="E-mailadres" sortable>
                            {{ props.row.email }}
                        </b-table-column>

                        <b-table-column v-slot="props" field="organisations" label="Organisatie(s)" :visible="user.role === 'pit'" sortable>
                            <span v-if="props.row.organisations.length === 1">
                                {{ props.row.organisations[0].organisation.name }}
                            </span>
                            <span v-else>
                                {{ props.row.organisations.length }} organisaties
                            </span>
                        </b-table-column>

                        <b-table-column v-slot="props" label="Acties" v-if="(user.is_admin || user.role == 'pit') || user.is_admin">
                            <b-tooltip label="Verwijderen" type="is-dark">
                                <b-button type="is-danger" icon-left="trash-alt" size="is-small" v-if="user.is_admin || user.role == 'pit'" @click="promptDeleteUserModal(props.row)"/>
                            </b-tooltip>
                            <b-tooltip label="Maak administrator" type="is-dark" v-if="!props.row.is_admin && props.row.role != 'admin'">
                                <b-button type="is-primary" icon-left="shield-alt" size="is-small" v-if="!props.row.is_admin || (user.is_admin || user.role == 'pit')" @click="promptMakeAdminModal(props.row)"/>
                            </b-tooltip>
                            <b-tooltip label="Administrator" type="is-dark" v-else-if="props.row.is_admin">
                                <b-button icon-left="shield-alt" type="is-light" size="is-small" disabled />
                            </b-tooltip>
                        </b-table-column>

                        <b-table-column v-slot="props" field="created_at" label="Aangemaakt op" sortable>
                            <span>{{ props.row.created_at|humanDate }}</span>
                        </b-table-column>

                        <b-table-column v-slot="props" v-if="user.is_admin || user.role == 'pit'" numeric>
                            <b-button type="is-primary" outlined size="is-small">
                                Aanpassen
                            </b-button>
                        </b-table-column>
                    </template>

                    <template #empty>
                        <section class="section">
                            <div class="content has-text-grey has-text-centered">
                                <p class="margin0" v-if="loading === false">Geen accounts gevonden.</p>
                                <p class="margin0" v-else>Laden...</p>
                            </div>
                        </section>
                    </template>
                </b-table> -->
            </div>
        </div>
    </div>
</template>

<script>
import UsersOverviewTable from '../users/UsersOverviewTable'

import filtersMixin from '@/mixins/filterMixins'
import toastMixin from '@/mixins/toastMixins'

export default {
    name: 'AccountsOverview',

    components: {
        UsersOverviewTable
    },

    mixins: [filtersMixin, toastMixin],

    data(){
        return {
            loading: true,

            records: [],
            total: null,
            sortField: 'updated_at',
            sortOrder: 'desc',
            defaultSortOrder: 'desc',
            page: 1,
            perPage: 20,

            searchParams: typeof(this.$store.state.searchQueries['AccountsOverview']) != 'undefined' ? this.$store.state.searchQueries['AccountsOverview'] : null,

            showMakeAdminModal: false,
            makeAdminUser: {},
            makeAdminLoading: false,

            showDeleteUserModal: false,
            deleteThisUser: {},
            deleteUserLoading: false
        }
    },

    computed: {
        paginated(){
            return this.records ? this.records.length < this.total : false
        },

        user() {
            return this.$store.state.user
        },

        dataBelongsTo() {
            return this.$store.state.dataBelongsTo
        }
    },

    mounted() {
        this.$refs['UsersOverviewTable'].fetchUsers()
    },

    methods: {
        // loadAsyncData(){
        //     // Set filter params & admin params
        //     const params = this.setParams(this.searchParams, 'AccountsOverview')

        //     this.loading = true

        //     axios.get(`/api/accounts?${params}`, {
        //         headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
        //     }).then((response) => {
        //         this.records = []

        //         this.total = response.data.total
        //         this.page = response.data.current_page
        //         this.records = response.data.data

        //         this.$store.dispatch('setSearchQuery', {type: 'AccountsOverview', query: params})
        //     }).catch((error) => {
        //         console.error('[❌] Error while fetching the customers:', error)
        //         this.data = []
        //         this.total = null
        //     }).then(() => {
        //         this.loading = false
        //         this.searchParams = null
        //     })
        // },

        loadAsyncData() {
            // handled in component itself.
        },

        addUserModal() {
            this.$refs['UsersOverviewTable'].addUser()
        },

        makeAdmin() {
            this.makeAdminLoading = true

            // axios.post(`/api/accounts/makeadmin/${this.makeAdminUser.id}`, {}, {
            //     headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            // }).then((response) => {
            //     this.showMessage('Administrator aangepast!')
            //     this.loadAsyncData()
            //     this.makeAdminUser = {}
            // }).catch((e) => {
            //     this.showError(e.response.data.error)
            // }).then(() => {
            //     this.makeAdminLoading = false
            //     this.showMakeAdminModal = false
            // })
        },

        deleteUser() {
            this.deleteUserLoading = true

            // axios.post(`/api/accounts/delete/${this.deleteThisUser.id}`, {}, {
            //     headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            // }).then((response) => {
            //     this.showMessage('Account verwijderd!')
            //     this.loadAsyncData()
            //     this.deleteThisUser = {}
            // }).catch((e) => {
            //     this.showError(e.response.data.error)
            // }).then(() => {
            //     this.deleteUserLoading = false
            //     this.showDeleteUserModal = false
            // })
        },

        promptMakeAdminModal(user){
            this.makeAdminUser = user
            this.showMakeAdminModal = true
        },

        promptDeleteUserModal(user){
            this.deleteThisUser = user
            this.showDeleteUserModal = true
        }
    }
}
</script>